import React, { useEffect, useState } from 'react';
import Button from 'sushiweb/Button';
import Modal from 'sushiweb/Modal';
import PropTypes from 'prop-types';
import _noop from 'lodash-es/noop';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import Dropdown from 'sushiweb/Dropdown';
import MenuItem from 'sushiweb/MenuItem';
import { P } from 'sushiweb/Typography/Text';
import {
  applicableFlowTypes,
  currentFlowTypeEnum,
  invoiceAmountGreaterThanPending,
  invoicesStatusEnum,
  paymentPurposeEnum,
} from '../constants';
import { OnlinePaymentsGap } from '../PaymentUpdate/styles';
import {
  ActualPayableAmountForDiscountWrapper,
  ActualPayableAmountWrapper,
  AmountInput,
  CreateButtonWrapper,
  DiscountedIconText,
  DiscountedIconWrapper,
  DiscountedPayaleAmountWrapper,
  DropdownWrapper,
  FormWrapper,
  InputWrapper,
  InvoiceDetailsWrapper,
  PayableAmountWrapper,
  StyledInput,
} from './styles';
import { CHECKOUT_ONLINE_PAY_ROUTE } from '../../../../constants/routes';
import {
  DiscountIconSmall,
  SingleLineArrow,
} from '../../../../components/SVGs/commonSVGs';
import {
  formatAmountInRupees,
  getMonthAndYearFromDate,
  isCurrentMonth,
} from './onlinePaymentsHelpers';

const OnlinePaymentModal = ({
  isInvoiceSelected,
  invoice,
  isVisible,
  closeModal,
  heading,
  currentFlow,
  invoiceData,
  fetchingInvoices,
  fetchedInvoices,
}) => {
  const [amountBalance, setAmount] = useState('');
  const [selectedInvoice, setSelectedInovice] = useState({});
  const [description, setDescription] = useState('');
  const [invoicesList, setInvociesList] = useState([]);
  const [errorMSG, setErrorMSG] = useState('');

  const disabled =
    currentFlow === currentFlowTypeEnum.FLOW_TYPE_PPI
      ? !amountBalance
      : !amountBalance || !selectedInvoice.invoice_id || errorMSG !== '';

  const redirectURL =
    currentFlow === currentFlowTypeEnum.FLOW_TYPE_PPI
      ? CHECKOUT_ONLINE_PAY_ROUTE
      : `/payments/pay-invoice/${selectedInvoice.start_date}/${
          selectedInvoice.end_date
        }`;
  useEffect(() => {
    if (isInvoiceSelected) {
      setSelectedInovice(invoice);
      setAmount(Math.floor(invoice.pending_amount));
    }
  }, [isInvoiceSelected]);
  useEffect(() => {
    if (!isInvoiceSelected && !fetchingInvoices && fetchedInvoices) {
      const invoices = [];
      invoiceData.forEach(data => {
        if (
          data.status === invoicesStatusEnum.GENERATED_UNPAID ||
          data.status === invoicesStatusEnum.PARTIALLY_PAID
        )
          invoices.push(data);
      });
      if (invoices.length > 0) {
        setSelectedInovice(invoices[0]);
        setAmount(Math.floor(invoices[0].pending_amount));
      }
      setInvociesList(invoices);
    }
  }, [fetchingInvoices]);

  useEffect(() => {
    if (amountBalance > selectedInvoice.pending_amount) {
      setErrorMSG(invoiceAmountGreaterThanPending);
    }
    // else if (amountBalance > 1000000) {
    //   setErrorMSG(invoiceAmountGreaterThan10L);
    // }
    else {
      setErrorMSG('');
    }
  }, [amountBalance, selectedInvoice]);
  const updateAmount = val => {
    if (val.length === 0) {
      setAmount('');
    }
    setAmount(val.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1'));
  };
  const updateDescription = val => {
    setDescription(val);
  };

  const checkoutPayment = () => {
    localStorage.onlinePaymentAmount = amountBalance;
    localStorage.paymentPurpose =
      currentFlow === currentFlowTypeEnum.FLOW_TYPE_LIMIT
        ? paymentPurposeEnum.PAYMENT_PURPOSE_INVOICE
        : paymentPurposeEnum.PAYMENT_PURPOSE_PPI;
    closeModal();
  };
  const handleSelect = val => {
    setSelectedInovice(val);
    setAmount(Math.floor(val.pending_amount));
  };
  const invoiceIDsMenuItems = () => {
    return invoicesList.map(value => {
      return <MenuItem value={value} label={value.invoice_id} />;
    });
  };
  const RedirectToCheckout = styled(NavLink)`
    text-decoration: none;
  `;

  return (
    <Modal
      visible={isVisible}
      onClose={closeModal}
      showCloseIcon
      title={heading}
      isCentered
    >
      <OnlinePaymentsGap />
      <FormWrapper>
        {currentFlow === currentFlowTypeEnum.FLOW_TYPE_LIMIT ? (
          <>
            {isInvoiceSelected || !selectedInvoice.invoice_id ? (
              // <DisabledInputWrapper>
              //   <StyledInput
              //     innerWidth='100%'
              //     value={
              //       !selectedInvoice.invoice_id
              //         ? 'No unpaid invoices'
              //         : selectedInvoice.invoice_id
              //     }
              //     disabled
              //   />
              // </DisabledInputWrapper>
              <InvoiceDetailsWrapper>
                <P>
                  &#x2022; Statement -
                  {selectedInvoice.invoice_id}
                </P>
                <P>
                  &#x2022; Amount -
                  {' '}
                  {selectedInvoice?.applied_discount_details?.request_id &&
                  selectedInvoice?.applied_discount_details?.request_id !==
                    '' &&
                  !isCurrentMonth(selectedInvoice?.start_date) ? (
                    <PayableAmountWrapper>
                      <ActualPayableAmountForDiscountWrapper>
                        {' '}
                        {formatAmountInRupees(
                          selectedInvoice?.applied_discount_details
                            ?.actual_payable_amount ?? '',
                        )}
                      </ActualPayableAmountForDiscountWrapper>
                      {' '}
                      <DiscountedPayaleAmountWrapper>
                        {formatAmountInRupees(
                          selectedInvoice?.applied_discount_details
                            ?.discounted_amount,
                        )}
                      </DiscountedPayaleAmountWrapper>
                      <DiscountedIconWrapper>
                        <DiscountIconSmall />
                        <DiscountedIconText>
                          {
                            selectedInvoice?.applied_discount_details
                              ?.discount_percent
                          }
                          % OFF
                        </DiscountedIconText>
                      </DiscountedIconWrapper>
                    </PayableAmountWrapper>
                  ) : (
                    <ActualPayableAmountWrapper>
                      {formatAmountInRupees(
                        selectedInvoice?.payable_amount ?? '',
                      )}
                      {' '}
                    </ActualPayableAmountWrapper>
                  )}
                </P>
                <P>
                  &#x2022; Pending amount -
                  {' '}
                  {formatAmountInRupees(selectedInvoice.pending_amount)}
                </P>
                <P>
                  &#x2022; Time period -
                  {' '}
                  {getMonthAndYearFromDate(selectedInvoice.start_date, true)}
                </P>
              </InvoiceDetailsWrapper>
            ) : (
              <DropdownWrapper>
                <Dropdown
                  value={selectedInvoice.invoice_id}
                  onSelect={handleSelect}
                  width='460px'
                >
                  {invoiceIDsMenuItems()}
                </Dropdown>
              </DropdownWrapper>
            )}
            <InputWrapper>
              {!selectedInvoice.invoice_id ? (
                <StyledInput
                  innerWidth='100%'
                  value='Amount to be paid'
                  disabled
                />
              ) : (
                <AmountInput
                  fullWidth
                  label='Amount to be paid'
                  value={amountBalance}
                  onChange={updateAmount}
                  errorMsg={errorMSG}
                />
              )}
            </InputWrapper>
          </>
        ) : (
          <>
            <InputWrapper>
              <StyledInput
                fullWidth
                label='Amount to be transferred'
                value={amountBalance}
                onChange={updateAmount}
              />
            </InputWrapper>
            <InputWrapper>
              <StyledInput
                fullWidth
                label='Description (optional)'
                value={description}
                onChange={updateDescription}
              />
            </InputWrapper>
          </>
        )}
      </FormWrapper>
      <CreateButtonWrapper>
        {disabled ? (
          <Button icon={<SingleLineArrow />} iconAlign='right' disabled>
            Continue
          </Button>
        ) : (
          <RedirectToCheckout to={redirectURL}>
            <Button
              onClick={checkoutPayment}
              icon={<SingleLineArrow />}
              iconAlign='right'
            >
              Continue
            </Button>
          </RedirectToCheckout>
        )}
      </CreateButtonWrapper>
    </Modal>
  );
};

OnlinePaymentModal.propTypes = {
  isInvoiceSelected: PropTypes.bool,
  invoice: PropTypes.objectOf(PropTypes.any),
  isVisible: PropTypes.bool,
  closeModal: PropTypes.func,
  heading: PropTypes.string,
  currentFlow: PropTypes.oneOf(applicableFlowTypes),
  invoiceData: PropTypes.arrayOf(PropTypes.any),
  fetchingInvoices: PropTypes.bool,
  fetchedInvoices: PropTypes.bool,
};

OnlinePaymentModal.defaultProps = {
  isInvoiceSelected: false,
  invoice: {},
  isVisible: true,
  closeModal: _noop,
  heading: '',
  currentFlow: currentFlowTypeEnum.FLOW_TYPE_PPI,
  invoiceData: [],
  fetchingInvoices: true,
  fetchedInvoices: true,
};

export default OnlinePaymentModal;
